import { NgModule } from "@angular/core";
import { SharedModule } from "@partner/shared/shared.module";
import { SignUpRoutingModule } from "./sign-up-routing.module";
import { SignUpComponent } from "./sign-up.component";

@NgModule({
  imports: [SharedModule, SignUpRoutingModule],
  declarations: [SignUpComponent],
})
export class SignUpModule { }
